// Shared non-component exports; keep component modules valid Fast Refresh boundaries.

import { fmtDateNZ } from "../../lib/format";

export function fmtNum(n: number): string {
  return n.toLocaleString();
}

export function fmtAvg(n: number | null): string {
  if (n == null) return "—";
  return n.toFixed(n >= 10 ? 0 : 1);
}

export function fmtDateOnly(s: string | null): string {
  if (!s) return "—";
  // Date-only strings (YYYY-MM-DD) come from the server as the calendar
  // day in UTC; parse the parts directly so the displayed day doesn't
  // shift in browsers running in non-UTC timezones. Full timestamps fall
  // back to the regular Date parser.
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s);
  if (m) {
    return `${m[3]}/${m[2]}/${m[1]}`;
  }
  const d = new Date(s);
  return fmtDateNZ(d);
}

export function fmtTimeOfDay(s: number | null): string {
  if (s == null) return "—";
  const total = Math.round(s);
  const hh = Math.floor(total / 3600) % 24;
  const mm = Math.floor((total % 3600) / 60);
  const ampm = hh >= 12 ? "pm" : "am";
  const h12 = ((hh + 11) % 12) + 1;
  return mm === 0 ? `${h12}${ampm}` : `${h12}:${String(mm).padStart(2, "0")}${ampm}`;
}

export function fmtMissingRange(r: { start: string; end: string; days: number }): string {
  if (r.start === r.end) return fmtDateOnly(r.start);
  return `${fmtDateOnly(r.start)} – ${fmtDateOnly(r.end)} (${r.days}d)`;
}
